module.exports = __webpack_public_path__ + "static/img/focusNewbg.d957475.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/sportsLogo/focusNewbg.png
// module id = rDcC
// module chunks = 9